import { render } from "./CounterROIList.vue?vue&type=template&id=ad532f32&ts=true"
import script from "./CounterROIList.vue?vue&type=script&lang=ts"
export * from "./CounterROIList.vue?vue&type=script&lang=ts"

import "./CounterROIList.vue?vue&type=style&index=0&id=ad532f32&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__